import { Oauth2Configuration } from 'angular-auth';
import { Settings } from 'luxon';

import { AppConfig, BreakPoint } from 'app.config';
import { CSSEditorStyles } from 'cms/cms-shared/cms-text-editor/cms-text-editor-styles';
import { AnalyticsAction } from 'cms/cms-shared/models/analytics-action/analytics-action.models';
import { EcommerceBrandSettings, AppIdEnum } from 'idt-ecommerce-api/config/config.models';
import { ContinentStoresConfig } from 'idt-ecommerce-api/stores/stores.models';
import { RenderConfiguration } from 'render/render.config';


Settings.defaultLocale = 'es';

export interface CmsConfiguration extends AppConfig {
  apiBaseUrl: string;
  enableGraphQlCompression?: boolean;
  apiProtectedBaseUrl: string;
  jsonDraftUrl: string;
  jsonPublishedUrl: string;
  appPreviewBaseUrl: string;
  apiMaterializedUrl: string;
  romanUrl: string | null;
  disableGuard?: boolean;
  disallowInsecure?: boolean;
  textStyles: TextStyle[];
  colorStyles: string[];
  groupStoresBySaleStatus?: boolean;
  storesGroup?: ContinentStoresConfig[];
  breakpoints: BreakPointPreview[];
  imPolicyList: string[];
  analyticsActionsTypes?: AnalyticsAction[];
  appInsightsConnectionString?: string;
  oauthConfig: Oauth2Configuration;
  notifierUrl?: string;
}

export type EnvironmentName = 'LOCAL' | 'DES' | 'PRE' | 'PRO';
export type EnvironmentMap = {
  [name in EnvironmentName]: {
    cms: CmsConfiguration;
    render: RenderConfiguration;
  }
};

export { EcommerceBrandSettings, AppIdEnum };

export interface TextStyle {
  name: string;
  class: string;
  styles: CSSEditorStyles;
}

export interface BreakPointPreview extends BreakPoint {
  previewDimensions: {
    width: number;
    height: number;
  };
}
